import { CCard, CCardBody, CCollapse } from "@coreui/react";
import moment from "moment";
import LocalizedStrings from "react-localization";

const DeviceDetails = ({ device }) => {
  return (
    <CCollapse visible={!!device?.id} style={styles.collapseCard}>
      <CCard key={device?.id}>
        <CCardBody>
          <h4 className="text-muted">
            {strings.details.title} "{device?.name}"
          </h4>
          <p className="text-muted">
            <b>{strings.details.description}:</b> {device?.description}
          </p>
          {/* <p className="text-muted">
      <b>{strings.details.status}:</b> {device?.actionOnOff}
    </p> */}
          <p className="text-muted">
            <b>{strings.details.autoRefreshTime}:</b> {device?.autoRefreshTime}
          </p>
          <p className="text-muted">
            <b>{strings.details.brand}:</b> {device?.brand}
          </p>
          <p className="text-muted">
            <b>{strings.details.currency}:</b> {device?.currency}
          </p>
          <p className="text-muted">
            <b>{strings.details.energyCost}:</b> {device?.energyCost}
          </p>
          <p className="text-muted">
            <b>{strings.details.timezone}:</b> {device?.timezone}
          </p>
          <p className="text-muted">
            <b>{strings.details.createdAt}:</b>{" "}
            {moment(device?.createdAt).format("YYYY-MM-DD HH:mm:ss")}
          </p>
        </CCardBody>
      </CCard>
    </CCollapse>
  );
};

const strings = new LocalizedStrings({
  es: {
    details: {
      title: "Detalles del dispositivo",
      description: "Descripción",
      status: "Estado",
      autoRefreshTime: "Tiempo de refresco automático",
      brand: "Marca",
      currency: "Moneda",
      energyCost: "Costo de energía",
      timezone: "Zona horaria",
      createdAt: "Fecha de creación",
    },
  },
});

const styles = {
  collapseCard: { marginTop: "15px" },
};

export default DeviceDetails;
